
import { defineComponent } from '@nuxtjs/composition-api';
import JobsHiringsCountMixin from '@/components/common/BravadoRightNavigation/JobsHiringsCountMixin';
import WarRoomUnreadPostsCountMixin from '@/components/common/BravadoRightNavigation/WarRoomUnreadPostsCountMixin';
import type { IMenuItem } from '@/components/common/BravadoRightNavigation/constants';
import { getMenuItems } from '@/components/common/BravadoRightNavigation/constants';
import type { CurrentUser } from '@/types';

export default defineComponent({
  name: 'BravadoRightNavigation',
  mixins: [JobsHiringsCountMixin, WarRoomUnreadPostsCountMixin],
  props: {
    hideMenu: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visibleItems(): IMenuItem[] {
      return getMenuItems({
        user: this.$auth.user as CurrentUser,
        unreadPostsMessage: this.unreadPostsMessage,
        hiringCount: this.hiringCount,
      });
    },
  },
  methods: {
    onClick(item: IMenuItem): void {
      this.$analytics.logEvent('war-room__sidebar-navigation__click', {
        to: item.label.replaceAll(' ', '-').toLowerCase(),
      });
    },
  },
});
